const components = {
  MuiCssBaseline: {
    styleOverrides: (theme) => ({
      "a, a:visited": {
        color: theme.palette.mode === "dark" ? "#60a5fa !important" : "#2563eb",
        textDecoration: "none",
      },
      "a:hover, a:focus": {
        color: theme.palette.mode === "dark" ? "#93c5fd !important" : "#1d4ed8",
        textDecoration: "underline",
      },
    }),
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true,
    },
  },
  MuiLink: {
    defaultProps: {
      underline: "hover",
    },
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.mode === "dark" ? "#60a5fa !important" : "#2563eb !important",
        "&:visited": {
          color: theme.palette.mode === "dark" ? "#60a5fa !important" : "#2563eb !important",
        },
        "&:hover, &:focus": {
          color: theme.palette.mode === "dark" ? "#93c5fd !important" : "#1d4ed8 !important",
        },
      }),
    },
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6",
      },
    },
    styleOverrides: {
      action: {
        marginTop: "-4px",
        marginRight: "-4px",
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
        boxShadow: "rgba(50, 50, 93, 0.025) 0px 2px 5px -1px, rgba(0, 0, 0, 0.05) 0px 1px 3px -1px",
        backgroundImage: "none",
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none",
      },
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      day: {
        fontWeight: "300",
      },
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      root: {
        height: "64px",
      },
    },
  },
  MuiPickersCalendar: {
    styleOverrides: {
      transitionContainer: {
        marginTop: "6px",
      },
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      iconButton: {
        backgroundColor: "transparent",
        "& > *": {
          backgroundColor: "transparent",
        },
      },
      switchHeader: {
        marginTop: "2px",
        marginBottom: "4px",
      },
    },
  },
  MuiPickersClock: {
    styleOverrides: {
      container: {
        margin: `32px 0 4px`,
      },
    },
  },
  MuiPickersClockNumber: {
    styleOverrides: {
      clockNumber: {
        left: `calc(50% - 16px)`,
        width: "32px",
        height: "32px",
      },
    },
  },
  MuiPickerDTHeader: {
    styleOverrides: {
      dateHeader: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
      timeHeader: {
        "& h3": {
          fontSize: "3rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiPickersTimePicker: {
    styleOverrides: {
      hourMinuteLabel: {
        "& h2": {
          fontSize: "3.75rem",
          fontWeight: 300,
        },
      },
    },
  },
  MuiPickersToolbar: {
    styleOverrides: {
      toolbar: {
        "& h4": {
          fontSize: "2.125rem",
          fontWeight: 400,
        },
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: "6px",
        "&.MuiAutocomplete-tag": {
          color: "white", // Chip text color
          backgroundColor: "blue", // Chip background color
        },
      },
      deleteIcon: {
        color: "white", // Default delete icon color
        "&:hover": {
          color: "red", // Hover color for the delete icon
        },
      },
    },
  },
  //shrink input label size
  MuiOutlinedInput: {
    styleOverrides: {
      notchedOutline: {
        fontSize: "18px",
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      outlined: {
        "&.MuiInputLabel-shrink": {
          fontSize: "18px",
          transform: "translate(14px, -19px) scale(0.75)",
        },
      },
    },
  },
  //Required * star color as red
  MuiFormLabel: {
    styleOverrides: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      root: ({ theme }) => ({
        border: "none",
        "& .MuiDataGrid-row.even-row": {
          backgroundColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.03) !important"
              : "#f9f9f9 !important",
        },
        "& .MuiDataGrid-row.odd-row": {
          backgroundColor:
            theme.palette.mode === "dark" ? "transparent !important" : "#ffffff !important",
        },
        "& .MuiDataGrid-row": {
          color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.9) !important" : "inherit",
        },
        "& .MuiDataGrid-cell": {
          fontSize: "13px",
          color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.9) !important" : "inherit",
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.1) !important"
              : "rgba(224, 224, 224, 1) !important",
        },
        "& a, & a:visited": {
          color: theme.palette.mode === "dark" ? "#60a5fa !important" : "#2563eb !important",
          fontWeight: 600,
          textDecoration: "none",
        },
        "& a:hover, & a:focus": {
          color: theme.palette.mode === "dark" ? "#93c5fd !important" : "#1d4ed8 !important",
          textDecoration: "underline",
        },
        "& .MuiDataGrid-columnHeaders": {
          fontSize: "14px",
          backgroundColor:
            theme.palette.mode === "dark" ? "#151e2b !important" : "#f1f5f9 !important",
          color: theme.palette.mode === "dark" ? "#ffffff !important" : "#1e293b !important",
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.1) !important"
              : "rgba(224, 224, 224, 1) !important",
        },
        "& .MuiDataGrid-columnHeaderTitle": {
          color: theme.palette.mode === "dark" ? "#ffffff !important" : "#1e293b !important",
          fontWeight: 600,
        },
        "& .MuiDataGrid-footerContainer": {
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(255, 255, 255, 0.1) !important"
              : "rgba(224, 224, 224, 1) !important",
          color: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.9) !important" : "inherit",
          backgroundColor:
            theme.palette.mode === "dark" ? "#151e2b !important" : "#ffffff !important",
        },
        "& .MuiTablePagination-root, & .MuiTablePagination-selectIcon, & .MuiTablePagination-actions, & .MuiButtonBase-root":
          {
            color:
              theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.9) !important" : "inherit",
          },
      }),
    },
  },
};

export default components;
